import { BUILD_TRAY_OPEN } from '@instructure/quiz-common';
import { connect } from '../../../common/react-redux';
import NavWrapper from './presenter';
function mapStateToProps(state) {
  return {
    trayOpen: !!state.getIn(['ui', BUILD_TRAY_OPEN])
  };
}
export default connect(mapStateToProps)(NavWrapper);